import { Route } from "@dashboard/components/Router";
import React from "react";
import { Redirect, Switch } from "react-router-dom";

import { WizardGuard } from "../components/WizardGuard";
import { WizardLayout } from "../components/WizardLayout";
import { useWizardContext , WizardProvider } from "../context/WizardContext";
import { CatalogStep } from "../steps/Catalog";
import { CompanyInformationStep } from "../steps/CompanyInformation";
import { ContentPagesStep } from "../steps/ContentPages";
import { PaymentStep } from "../steps/Payment";
import { ShippingStep } from "../steps/Shipping";
import { TaxesStep } from "../steps/Taxes";
import { WizardStepId } from "../types";
import { WIZARD_STEPS, wizardBasePath, wizardStepPath } from "../urls";

const STEP_COMPONENTS: Record<WizardStepId, React.ComponentType> = {
  "company-information": CompanyInformationStep,
  "catalog": CatalogStep,
  "content-pages": ContentPagesStep,
  "taxes": TaxesStep,
  "payment": PaymentStep,
  "shipping": ShippingStep,
};

const WizardEntryRedirect = () => {
  const { completedSteps, skippedSteps } = useWizardContext();
  const isStepDone = (id: WizardStepId) => completedSteps.includes(id) || skippedSteps.includes(id);
  const targetStep = WIZARD_STEPS.find(step => !isStepDone(step.id)) ?? WIZARD_STEPS[0];

  return <Redirect to={wizardStepPath(targetStep.urlSegment)} />;
};

export const WizardRouter: React.FC = () => (
  <WizardGuard>
    <WizardProvider>
      <WizardLayout>
        <Switch>
          <Route exact path={wizardBasePath} component={WizardEntryRedirect} />
          {WIZARD_STEPS.map(step => (
            <Route
              key={step.id}
              exact
              path={wizardStepPath(step.urlSegment)}
              component={STEP_COMPONENTS[step.id]}
            />
          ))}
          {/* Catch all non-wizard paths (e.g. "/") and redirect to wizard */}
          <Redirect to={wizardStepPath(WIZARD_STEPS[0].urlSegment)} />
        </Switch>
      </WizardLayout>
    </WizardProvider>
  </WizardGuard>
);
